export const borderWidths = [
  '0.125rem',
  '0.25rem',
  '0.375rem',
  '0.5rem',
  '0.625rem',
  '0.75rem',
  '0.875rem',
  '1rem',
]

export const radii = [
  '0.375rem',
  '0.5rem',
  '0.875rem',
  '1rem',
  '1.25rem',
  '1.5rem',
  '1.75rem',
  '2rem',
  '2.5rem',
  '3rem',
  '3.5rem',
  '4rem',
  '4.5rem',
  '5rem',
  '5.5rem',
  '6rem',
  '6.4rem',
]
radii['squircle'] = '33.3333333333%'
radii['circle'] = '50%'
